module.exports = __webpack_public_path__ + "static/media/hollow_bar_liquidStrip_tall.db49cfea.svg";